/**
 * @name v0.1.3版本过渡
 * @params { Object } formData 表单数据
 * @returns { Object } 过渡之后的数据
 * @author liuguisheng
 * @version 2020-4-21
 * 
*/
// 导入v0.1.1数据格式
import * as v011 from './v012.js';

export const upgrade = function ( formData ) {
    // 取出当前版本
    let { version } = formData;
    if ( version == '0.1.3') return formData;
    let currentData = v011.upgrade(formData);
    let { formMap } = currentData;
    // 添加配置
    for ( let key in formMap) {
        formMap[key].styleOption.paddingLeft = 0;
    }
    // 版本号更新
    currentData.version = '0.1.3';
    return currentData;
}


// WEBPACK FOOTER //
// ./src/assets/version/v013.js